import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 40,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  title: {
    marginBottom: 18,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 10,
    },
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  subtitle: {
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      fontSize: 21,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  }
}));

const CancerCalculateHeader = ({ cancer = "폐암" }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      className={classes.header}
    >
      <Typography variant="h2" align="center" className={classes.title}>
        <span className={clsx(classes.large)}>
          나의 {cancer} 발생 위험도 계산하기
        </span>
        <span className={clsx(classes.small)}>
          나의 {cancer} 발생 위험도 계산하기
        </span>
      </Typography>
      <Typography variant="h4" color="textSecondary" align="center" >
        <span className={clsx(classes.subtitle, classes.large)}>
          귀하의 {cancer}의 위험도를 먼저 체크해보기시 바랍니다.
        </span>
        <span className={clsx(classes.subtitle, classes.small)}>
          귀하의 {cancer}의 위험도를 먼저 체크해보기시 바랍니다.
        </span>
        <span className={clsx(classes.subtitle, classes.large)}>
          <br />
          아래 항목에 본인에게 맞게 입력해주시고 ‘다음으로’ 버튼을 눌러주세요.
        </span>
        <span className={clsx(classes.subtitle, classes.small)}>
          아래 항목에 본인에게 맞게 입력해주시고
          <br /> ‘다음으로’ 버튼을 눌러주세요.
        </span>
        <br />
      </Typography>
    </Grid>
  );
};

export default CancerCalculateHeader;
